import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getProfile, getTop, getUsernameAndUrl } from "../api";
import "../i.css";
import { getProgressToNextLevel } from "../utils/leveling";
const CustomizeRank = () => {
  const [rank, setrank] = useState({
    url: "",
    name: "",
    color: "",
    curLevel: "",
    curRank: "",
    profileimg: "",
  });
  const [percentage, setpercentage] = useState(0);
  const user = useParams().userid;
  useEffect(() => {
    getTop(user).then((data) => {
      data.find((element, index) => {
        if (element.userid == user) {
          const rankimage = require("../rankImage.json");
          getUsernameAndUrl(element.userid).then((details) => {
            setrank({
              url: details.displayAvatarURL,
              name: details.tag,
              color: element.rankcolor,
              curLevel: element.level,
              curRank: index + 1,
              profileimg: rankimage.find((e) => {
                if (e.tag == element.currankimg) {
                  return e;
                }
              }),
            });
          });
          const progress = getProgressToNextLevel(element.points, element.level);
          setpercentage(progress.percentage);
        }
      });
    });

  }, []);
  const rankimg = {
    backgroundImage: `url(${rank.profileimg.url})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat"
  }
  const usersbar = {
    background: rank.color,
    width: `${percentage}%`,
  };
  console.log(rank)
  return (
    <div className="rankcard"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        width: "1500px",
        letterSpacing: "1px",
      }}
    >
      <div
        className="UserDetails"
        style={{
          backgroundColor: "black",
          height: "465px",
          color: "white",
          textAlign: "center",
        }}
      >
        <div
          className="levelAndPos"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            padding: "10px",
          }}
        >
          <h1 style={{ textAlign: "left", paddingLeft: "15px", fontSize: "40px" }}>
            #{rank.curRank}
          </h1>
          <h1 style={{ textAlign: "end", paddingRight: "15px", fontSize: "40px" }}>
            Level : {rank.curLevel}
          </h1>
        </div>
        <div style={{ padding: "10px" }}>
          <img
            src={rank.url}
            alt="rankimg"
            style={{
              height: "150px",
              width: "150px",
              borderRadius: "75px",
              display: "inline"
            }}
          />
          <h3 style={{ fontSize: "35px", marginTop: "15px" }}>{rank.name}</h3>
          <div class="meter">
            <span style={usersbar}></span>
          </div>
        </div>
      </div>
      <div
        className="TheirImage"
        style={rankimg}
      ></div>
    </div>
  );
};

export default CustomizeRank;
